import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const LikelyToSubscribe = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 128 128" fill="none" {...props}>
    <path
      d="M12.8 64C12.8 77.5791 18.1943 90.602 27.7961 100.204C37.398 109.806 50.4209 115.2 64 115.2C77.5791 115.2 90.602 109.806 100.204 100.204C109.806 90.602 115.2 77.5791 115.2 64C115.2 50.4209 109.806 37.398 100.204 27.7961C90.602 18.1943 77.5791 12.8 64 12.8C50.4209 12.8 37.398 18.1943 27.7961 27.7961C18.1943 37.398 12.8 50.4209 12.8 64Z"
      fill="#FAECAD"
    />
    <path d="M25.4874 40.3456H102.514V89.1917H25.4874V40.3456Z" fill="white" />
    <path
      d="M25.4874 40.3456H102.514V89.1917H25.4874V40.3456Z"
      stroke="#997D00"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.8957 42.3987L61.9827 66.999C62.5856 67.3828 63.2854 67.5866 64 67.5866C64.7146 67.5866 65.4144 67.3828 66.0173 66.999L102.104 42.3987C101.789 41.7817 101.31 41.2639 100.719 40.9024C100.128 40.541 99.4486 40.35 98.7558 40.3507H29.2442C28.5514 40.35 27.872 40.541 27.2811 40.9024C26.6901 41.2639 26.2107 41.7817 25.8957 42.3987Z"
      fill="white"
      stroke="#997D00"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.3315 89.0752L53.1955 66.6509"
      stroke="#997D00"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M99.6723 89.0777L73.7267 65.6793"
      stroke="#997D00"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.9539 56.3828C57.0253 51.5981 51.5264 56.498 52.2457 61.7204C52.8512 66.112 59.3011 70.3501 63.3126 74.0967C63.4865 74.2584 63.7151 74.3484 63.9526 74.3484C64.1901 74.3484 64.4188 74.2584 64.5926 74.0967C68.6041 70.3488 75.0553 66.1108 75.6595 61.7191C76.3814 56.498 70.8825 51.5981 63.9539 56.3828Z"
      fill="#FAECAD"
      stroke="#997D00"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
